<template>
  <section class="realtor_listing full_screen">

      <template v-if="isMobile">
        <b-button v-if="!modeMap" type="is-primary map_mode_mobile" icon-left="map"
                  @click="modeMap = !modeMap">Map
        </b-button>
        <b-button v-if="modeMap" type="is-primary map_mode_mobile" icon-left="view-dashboard"
                  @click="modeMap = !modeMap">List
        </b-button>

        <b-button type="is-primary map_mode_mobile filter_mobile" icon-left="format-align-center"
                  @click.stop="$refs.filters_mobile.isMoreFilterModalActive = true">Filter
        </b-button>
      </template>
      <div class="main_container" ref="main">

        <div class="search_container">
          <div class="top-filter-box">
            <div v-if="isMobile">
              <div class="top-filter-box-mobile-search">
                <filters_mobile
                  @selectProperty="selectProperty"
                  @apply="apply"
                  @selectCity="selectCity"
                  @selectListing="selectListing"
                  @selectAddress="selectAddress"
                  v-model="query"
                  ref="filters_mobile"
                />
              </div>
            </div>
            <filters
              v-if="!isMobile"
              @selectProperty="selectProperty"
              @apply="apply"
              @selectCity="selectCity"
              @selectListing="selectListing"
              @selectAddress="selectAddress"
              v-model="query"
            />
          </div>
<!--          <h3 class="subtitle" v-if="computed_items.title">{{ computed_items.title.default }}</h3>-->
        </div>
        <div class="content_container" ref="main">
        <template v-if="listIsVisible">
          <div class="list_container">
            <b-loading :is-full-page="false" v-model="isListingLoading" :can-cancel="true"></b-loading>
            <div class="row">
              <div class="col-12">
                <h1 class="is-size-5 mb-2">
                <span
                  v-if="this.realtor"
                >{{this.realtor.first_name}} {{this.realtor.last_name}} </span>
                <span v-if="query.filter.deal_type !== 'RENT'"
                  ><span>{{property_type_map.hasOwnProperty(query.filter.property_type) ? property_type_map[query.filter.property_type] : 'Real Estate & Homes'}}</span> <span>For Sale</span></span>

                <span
                  v-if="query.filter.deal_type === 'RENT'"
                  >Rental listing</span>

                </h1>
                <section class="mb-3">
                  <b-field>
                    <b-tag size="is-medium">{{ result.total}} Listings</b-tag>
                  </b-field>
                </section>
              </div>
              <div class="col-md-6 property_item" v-for="(option, index) in result.items" v-bind:key="index">
                <a class="has-text-black" :href="getUrlFromItem(option)" target="_blank">
                  <detail
                    :items="option"
                    :key="index"></detail>
                </a>
              </div>
            </div>

<!--            <div class="p-2">-->
<!--              <b-pagination-->
<!--                v-if="result && result.total"-->
<!--                :total="result.total > 1000 ? 1000 : result.total "-->
<!--                v-model="query.page"-->
<!--                :range-before="3"-->
<!--                :range-after="4"-->
<!--                :simple="false"-->
<!--                :rounded="false"-->
<!--                :per-page="query.limit"-->
<!--                icon-prev="chevron-left"-->
<!--                icon-next="chevron-right"-->
<!--                aria-next-label="Next page"-->
<!--                aria-previous-label="Previous page"-->
<!--                aria-page-label="Page"-->
<!--                aria-current-label="Current page">-->
<!--              </b-pagination>-->
<!--            </div>-->

          </div>

        </template>
        <template v-if="mapIsVisible">
          <div id="map-wrap" class="map-box map_container">
            <leaflet
              ref="map"
              :items="result"
              :onPinClick="openLinkByItem"
              @onMapMove="onMove"
              @onMapInitialized="onMapInitialized"
              :city="query.city"
              @clearCity="query.city = null"
            />
          </div>
        </template>
        </div>
      </div>

    <b-modal
      v-model="isComponentModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      close-button-aria-label="Close"
      aria-modal
      class="detailsModal"
    >

        <div class="modal-card" style="width: auto">
          <section class="modal-card-body px-0">
            fullDetail
<!--        <fullDetail-->
<!--          :item_url="selectedItemUrl"-->
<!--          :items="items"-->
<!--        >-->

<!--        </fullDetail>-->
          </section>
        </div>

    </b-modal>
  </section>
</template>

<script>

import L from "leaflet"
import {getCityById, getPropertiesByQuery} from "@/Helpers/repository";
import {Result} from "@/Helpers/propertiesQueryResult";
import {Query} from "@/Helpers/propertiesQueryBuilder";
import detail from "@/components/listings_map/listing_detail";
import leaflet from "@/components/listings_map/map/leaflet";
import _ from 'lodash';
import configDefault from "@/components/listings_map/map/config";
import {localCache} from "@/Helpers/localCache";
import filters from "@/components/listings_map/filters";
import filters_mobile from "@/components/listings_map/filters_mobile";

export default {
  name: 'front_realty_realtor_properties_list',
  components: { detail, leaflet,  filters, filters_mobile },
  //components: { detail, leaflet, FixedHeader,search, fullDetail, filters, filters_mobile },

  props: {
    items:null
  },
  data() {
    return {
      price_range_suggest_mode: "min",
      price_range_suggest:{
        "BUY": {
          "min" : [
            40000,
            80000,
            100000,
            120000,
            150000,
            180000
          ],
          "max" : [
            150000,
            180000,
            200000,
            250000,
            300000,
            450000,
          ]
        },
        "RENT": {
          "min" : [
              800,
              1000,
              1300,
              1500,
              1700,
              2000
            ],
          "max" : [
            1000,
            1300,
            1500,
            1800,
            2000,
            2300
          ]
        },
      },
      selectedItemUrl: null,
      deal_map : {
        "BUY": "For sale",
        "RENT" : "For rent"
      },
      property_type_map : {
        "RINC": "Multi-Family",
        "FARM" : "Farm",
        "RLSE" : "Residential Lease",
        "RESI" : "Residential",
        "BUSO" : "Business Opportunity",
        "COMS" : "Commercial Sale",
        "COML" : "Commercial Lease",
        "LAND" : "Land",
        "OTHER" : "OTHER"
      },
      default_items: {},
      query: new Query(),
      result: null,
      isListingLoading: false,
      prev: null,
      modeMap: false,
      address: null,
      cache: null,
      window_width: null,
      isComponentModalActive: false,
      mapPositionDone: false,
      fitBoundsOnNextRequest: false
    }
  },
  computed: {
    computed_items: function () {
      return this.items;
    },
    mapIsVisible: function () {
      return this.modeMap || !this.isMobile;
    },
    listIsVisible: function () {
      return !this.modeMap || !this.isMobile;
    },
    isMobile: function (){
      return this.window_width < 821
    },
    realtor: function () {
      //console.log(this.items);
      return this.items && this.items.realtor && this.items.realtor.default && this.items.realtor.default.realtor
        ? this.items.realtor.default.realtor : null;
    }
  },
  methods: {
    money(val) {
      return parseInt(val).toLocaleString('en-US', { style: 'currency', currency: 'USD',  minimumFractionDigits: 0,
        maximumFractionDigits: 0 });
    },
    kFormatter(num) {
      return Math.abs(num) > 3000 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : this.money(Math.sign(num)*Math.abs(num))
    },
    reportWindowSize() {

        this.window_width = window.innerWidth;

    },
    getHeaderHeight(){
      const header = document.getElementById('header');
      return header.offsetHeight;
    },
    openLink(url) {
      let urlFinal = url;
      if(document.location.host.indexOf('localhost') > -1) {
        urlFinal = 'http://demo.realty-s7.com:8000' + urlFinal;
      }
      window.open(urlFinal, '_blank');
    },
    openLinkByItem(item) {
      let url = item._source.SystemUrl;
      if(document.location.host.indexOf('localhost') > -1) {
        url = 'http://demo.realty-s7.com:8000' + url;
      }
      window.open(url, '_blank');
    },
    //link_method
    getUrlFromItem(item) {

      return item._source.SystemUrl;

     //  if(nav && !this.isMobile && !url_mode) {
     //    this.selectedItemUrl = (url_mode ? item :  item._source.SystemUrl);
     //    this.isComponentModalActive = true;
     //    return;
     //  }
     //  //let result =  this.items.details_url.default + '/' + (url_mode ? item :  item._source.SystemUrl);
     //  let result =  item._source.SystemUrl;
     // // let qAdded = false;
     //  if(this.realtor) {
     //    result = result + '?agent=' + this.realtor.id;
     //    //qAdded = true;
     //  }
     //  if(this.query) {
     //    //result = result + (!qAdded ? '?' : '') + this.query.toString();
     //  }
     //  if(nav) {
     //    this.$router.push(result);
     //  } else {
     //    return result;
     //  }
    },
    onMove(){
      if(!this.mapPositionDone) {
        return;
      }
      //console.log('onMove');
      this.setQueryFromBounds();
      this.request800();
    },
    setBoundsFromQuery(query) {
      //console.log('setBoundsFromQuery');
      this.$refs.map.uniSetBoundsFromQuery(query);
    },
    setQueryFromBounds() {
      const bounds = this.$refs.map.uniGetBounds();
      /**
       * @type {Query} query
       */
      if(bounds && bounds.ne_lat) {
        this.query.ne_lat = bounds.ne_lat;
        this.query.ne_lng = bounds.ne_lng;
        this.query.sw_lat = bounds.sw_lat;
        this.query.sw_lng = bounds.sw_lng;
      }
      //this.query.zoom = this.$refs.map.uniGetZoom();
    },
    // request() {
    //   if (process.client) {
    //     getPropertiesByQuery(this.query).then((result) => {
    //       this.result = result;
    //     });
    //   }
    // },
    apply(){
      this.syncFilter();
      this.request();
    },

    selectAddress(item, fitBounds = false) {
      this.query.filter.address = item.Address;
      this.fitBoundsOnNextRequest = fitBounds;
      if (fitBounds) {
        this.query.city = null;
        this.query.place_id = null;
        this.query.place_type = null;
      }
      this.request();
    },
    selectListing(item) {
      var zoom = 23;
      this.$refs.map.$refs.leaflet.mapObject.setView([item.location.lat, item.location.lon], zoom);
    },
    selectProperty(item) {
      if(this.isMobile) {
        this.openLinkByItem(item);
        return;
      }
      //console.log('item url');
      //console.log(item)
      //this.selectedItemUrl = item;
      this.openLink(item);
      //this.isComponentModalActive = true;
    },
    selectCity(city) {
      this.query.place_id = city;
      this.query.place_type = 'city';
      this.isListingLoading = true;
      getCityById(city).then((result) => {
        this.isListingLoading = false;
        //console.log(result);
        this.query.city = result;
        if(this.isMobile && this.listIsVisible) {
          this.query.initDefaultBounds();
          this.apply();
        }
      });
    },
    requestProperties() {

        this.isListingLoading = true;
        const query = this.query.clone();
        if (this.fitBoundsOnNextRequest) {
          query.initDefaultBounds();
        }
        // if(!query.geo_hash && this.window_width < 660) {
        //   query.ne_lat = null;
        //   query.ne_lng = null;
        //   query.sw_lat = null;
        //   query.sw_lng = null;
        // } else {
        query.limit = 50;
        query.page = 1;
        query.geo_hash = this.mapIsVisible && this.$refs.map.uniGetZoom() < configDefault.maxZoomForGeoHash.leaflet;
        if(query.geo_hash) {
          //query.limit = 0;
        }
        if(this.mapIsVisible && this.$refs.map.uniIsMapInitialized()) {
          const zoom = this.$refs.map.uniGetZoom();
          query.precision = configDefault.zoomToPrecision.leaflet[zoom];
        }
        // }
        if(!query.geo_hash && this.window_width > 660) {
          query.geo_hash = true;
        }
        // let resultFromCache = null, key = null;
        // key = query.toString();
        // if(this.cache.exist(key)) {
        //   this.result = this.cache.get(key);
        //   this.isListingLoading = false;
        //   document.location.hash = this.query.toString();
        //   return;
        // }
       // console.log(this.realtor);
        if(this.realtor) {
          query.mls_agent_id = this.realtor.id;
        }
        getPropertiesByQuery(query).then((result) => {
          this.result = result;
          this.isListingLoading = false;
          document.location.hash = this.query.toString();
          //this.cache.set(key, result);
          this.mapPositionDone = true;

          if (this.fitBoundsOnNextRequest && result.items && result.items.length > 0 && !this.query.city && !this.query.place_id) {
            const locations = result.items.map(item => [item._source.location.lat, item._source.location.lon]);
            const bounds = L.latLngBounds(locations);
            if (this.$refs.map && this.$refs.map.$refs.leaflet) {
              const map = this.$refs.map.$refs.leaflet.mapObject;
              const targetZoom = map.getBoundsZoom(bounds);
              map.setView(bounds.getCenter(), targetZoom - 1);
            }
          }
          this.fitBoundsOnNextRequest = false;
        });

    },
    request: _.debounce(function() {
      this.requestProperties();
    }, 300),
    request800: _.debounce(function() {
      this.requestProperties();
    }, 800),
    addressChange: _.debounce(function() {
     this.query.filter.address = this.address;
    }, 1000),
    syncFilter() {
      const property_type_deal_type = {
        "RINC": "BUY",
        "FARM": "BUY",
        "RLSE": "RENT",
        "RESI": "BUY",
        "BUSO": "BUY",
        "COMS": "BUY",
        "COML": "RENT",
        "LAND": "BUY",
        "OTHER": "BUY",
      };
      if(this.query.filter.property_type) {
        this.query.filter.deal_type = property_type_deal_type[this.query.filter.property_type];
        return true;
      }
      return false;
    },
    onMapInitialized() {
      if(this.mapIsVisible) {
        if (this.query.filter.address && !this.query.city && !this.query.place_id) {
          this.fitBoundsOnNextRequest = true;
        }
        this.setBoundsFromQuery(this.query);
        this.apply();
      }
    },
  },
  created() {
    this.cache = localCache;
    this.result = new Result();

  },
  mounted() {

      document.body.style.overflow = 'hidden';
      // document.getElementById('header').classList.add('header_class');
      // document.getElementById('footer').classList.add('footer_class');


    this.reportWindowSize();

      window.addEventListener("resize", this.reportWindowSize);

    if(this.result === null) this.result = new Result();
    this.query.fromString(document.location.hash);
    //this.address = this.query.filter.address;
    // console.log(this.query.filter.address);
    // console.log(this.isMobile);
    // console.log(this.mapIsVisible);
    // console.log(this.query.place_id);
    // console.log(this.query.place_type);
    if((!this.isMobile || this.mapIsVisible)
      && this.query.place_id
      && this.query.place_type === 'city'
    ) {
      this.selectCity(this.query.place_id);
    }

    if(this.isMobile){
      this.apply();
    }

  },
  unmounted() {
    this.result = null;
    this.query = null;
  },
  beforeDestroy() {

      document.body.style.overflow = null;
      var header = document.getElementById('header');
      if(header) {
        header.classList.remove('header_class');
      }
      var footer = document.getElementById('footer');
      if(footer) {
        footer.classList.remove('footer_class');
      }


  },
  watch: {
    query: {
      handler() {
        // if(!this.query.geo_hash) {
        //   this.query.initDefaultBounds();
        // }
        //console.log('change');
        //this.syncFilter();
        //this.request();
        // if(this.query.filter.address === null || this.query.filter.address === '') {
        //   this.query.city = null;
        // }
      },
      deep: true
    },
    modeMap: {
      handler() {
      }
    },
    address: {
      handler() {
        this.addressChange();
      }
    }
  },
}
</script>

<style scoped>
.price-range-suggest-item {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  cursor: pointer;
  padding-left: 20px;
  padding-right: 20px;
}

.price-range-suggest-item:hover {
  background: #f2f2f2;
}

.price-range-suggest-box {
  margin-left: -20px;
  margin-right: -20px;
}
.full_screen .main_container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content_container{
  overflow: hidden;
  display: flex;
  height: 100%;
  flex-direction: row-reverse;
}
.list_container {
  overflow-y: auto;
  flex: 0 0 750px;
  box-shadow: -2px 2px 5px 0 rgb(0 0 0 / 40%);
  padding: 1rem;
  z-index: 2;
  position: relative;
}
.search_container{
  padding: 0rem 1rem;
}
.map_container{
  position: relative;
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  z-index: 1;
}

/*.top-pag-box {*/
/*  display: flex;*/
/*  justify-content: flex-end;*/
/*}*/
.col-md-8.top-filter-box {
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: flex-start;*/
}
.location {
  width: 158px;
}
.property_type {
  /*width: 158px;*/
}
.mobile-search, .map_mode_mobile{
  display: none;
}
.map-box {
  /*height: 70vh;*/

}
@media screen and (max-width: 820px) {
  .map-box {
    height: calc(100vh - 111px);
    margin-right: calc(-.5 * 1.5rem);
    margin-left: calc(-.5 * 1.5rem);
  }
  .section.realtor_listing {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
  }
  .desktop-search {
    display: none;
  }
  .mobile-search{
    display: block;
  }
  .map_mode_mobile {
    display: block;
    position: fixed;
    bottom: 1rem;
    z-index: 39;
    left: calc(100vw/2 - 93px);
  }
  .map_mode_mobile.filter_mobile {
    left: calc(100vw/2);
  }
  .property_item{
    /*padding-left: 0;*/
    /*padding-right: 0;*/
  }
  .list_container {
    flex: auto;
    box-shadow: none;
    padding: 1rem;
    z-index: 2;
    position: relative;
  }

}
.top-filter-box-mobile-search.vue-fixed-header.vue-fixed-header--isFixed {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  z-index: 9;
  background: #FFF;
  padding: 0.1rem 0.5rem;
}

.search_container {
  border-top: 1px solid rgb(204, 204, 204);
  border-bottom: 1px solid rgb(204, 204, 204);
}
</style>
<style>

.header_class {
  height: 80px !important;
  width: 100% !important;
  max-width: 100% !important;
}
section.realtor_listing.full_screen {
  height: calc(100vh - 85px);
  overflow: hidden;
  /*position: relative;*/
}
@media screen and (max-width: 820px) {
  .header_class {
    height: 50px !important;
  }
  section.realtor_listing.full_screen {
    height: calc(100vh - 50px);
  }

  .header_class img.brand_logo {
    max-height: 32px !important;
  }
  .search_container {
    position: relative;
    top: 2px;
  }
}
.footer_class {
  display: none;
}



html, body {
  /*overflow: hidden;*/
}

.detailsModal .modal-card {
  height: 100vh;
  max-height: 100vh;
  /*width: 1000px !IMPORTANT;*/
  min-width: 960px;
  max-width: 100vw;
}

</style>
